import React, { useState } from 'react';
import Text from '../../../../Components/Base/Text/Text';
import Button from '../../../../Components/Button/Button';
import PatientInsuranceSetupVerifyModal from './PatientInsuranceSetupVerifyModal';

// @ts-ignore
import styles from './PatientInsuranceSetup.module.scss';

interface Props {
	patientId: string;
}

const PatientInsuranceSetup: React.FC<Props> = props => {
	const { patientId } = props;
	const [verifyInsuranceModalOpen, setVerifyInsuranceModalOpen] =
		useState<boolean>(true);

	return (
		<div className={styles.wrapper}>
			<div className={styles.loadingWrapper}>
				{!verifyInsuranceModalOpen && (
					<>
						<Text
							tx={'nczi.verifyPatientInsurance.cannotFindInsurance'}
							firstUpper
						/>
						<br />
						<Button
							title={'nczi.verifyPatientInsurance.verifyNow'}
							onClick={() => setVerifyInsuranceModalOpen(true)}
						/>
					</>
				)}
				<PatientInsuranceSetupVerifyModal
					opened={verifyInsuranceModalOpen}
					onClose={() => setVerifyInsuranceModalOpen(false)}
					patientId={patientId}
				/>
			</div>
		</div>
	);
};

export default PatientInsuranceSetup;
